// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"da702b79","315":"9b8d900c","569":"54adb4fd","732":"d5fa3268","798":"76b9c8a5","876":"a20e76a4"}[chunkId] + ".chunk.css";
};